import * as React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import { InviteUserProvider } from '../providers';

const styles: StyleRulesCallback = t => ({
  input: {
    marginBottom: 12
  },
  container: {
    width: 400
  }
});

interface Props {
  farmId: string;
  show: boolean;
  onDismiss: () => void;
}

interface State {
  email: string;
}

class InviteDialog extends React.Component<Props & WithStyles, State> {
  state = {
    email: ''
  };

  handleChangeEmail = (
    event: any
  ) => {
    event.preventDefault();
    this.setState({ email: event.currentTarget.value });
  };

  handleSubmit = async (e: any, mutateFn: () => void) => {
    e.preventDefault();
    mutateFn();
  };

  render() {
    const { classes, show, onDismiss } = this.props;
    return (
      <InviteUserProvider
        params={{
          email: this.state.email,
          farmId: this.props.farmId
        }}
        onCompleted={() => onDismiss()}
      >
        { (mutateFn, loading) =>
          <Dialog
            open={show}
            onClose={() => onDismiss()}
            onBackdropClick={() => onDismiss()}
            onEscapeKeyDown={() => onDismiss()}
          >
            <form onSubmit={evt => this.handleSubmit(evt, mutateFn)} className={classes.container}>
              <DialogTitle>Invitar Usuario</DialogTitle>
              <DialogContent>
                <TextField
                  type="email"
                  label="Email"
                  fullWidth={true}
                  onChange={this.handleChangeEmail}
                  value={this.state.email}
                  className={classes.input}
                  required={true}
                />
              </DialogContent>
              <DialogActions>
                <Button type="submit" color="primary" disabled={loading}>
                  Enviar
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        }
      </InviteUserProvider>
    );
  }
}

export default withStyles(styles)(InviteDialog);



// WEBPACK FOOTER //
// ./src/components/InviteDialog.tsx